module.exports = __webpack_public_path__ + "img/brand(10).e87c3b5d.png";